
import React from "react";
import PropTypes from "prop-types";

class CellFormatterTooltip extends React.Component {

  shouldComponentUpdate(nextProps) {
    return nextProps.value !== this.props.value;
  }

  render() {
    return <div>{this.props.value}</div>;
  }
}

CellFormatterTooltip.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.bool])
};

export default CellFormatterTooltip;